<template>
  <div class="allocation-user-storehouse-manage-container">
    <ds-page-header :title="$t('allocationUserStorehouseManage.page.title')"
      :subtitle="$t('allocationUserStorehouseManage.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-download" @click="exportExcel">
          {{ $t('common.export') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="queryAllocationUserStorehouse">
          {{ $t('common.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <ds-search-panel>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.ausId"
            :placeholder="$t('allocationUserStorehouseManage.search.ausId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.resId"
            :placeholder="$t('allocationUserStorehouseManage.search.resId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.resName"
            :placeholder="$t('allocationUserStorehouseManage.search.resName')" clearable />
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="allocationUserStorehouseManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-select v-model="allocationUserStorehouseManageInfo.conditions.parentRstId"
            :placeholder="$t('allocationUserStorehouseManage.search.parentRstId')" style="width:100%" clearable
            @change="listResourceStoreSonTypes">
            <el-option v-for="item in allocationUserStorehouseManageInfo.resourceStoreTypes" :key="item.rstId"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="allocationUserStorehouseManageInfo.conditions.rstId"
            :placeholder="$t('allocationUserStorehouseManage.search.rstId')" style="width:100%" clearable
            @change="listResourceStoreSpecifications">
            <el-option v-for="item in allocationUserStorehouseManageInfo.resourceStoreSonTypes" :key="item.rstId"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="allocationUserStorehouseManageInfo.conditions.rssId"
            :placeholder="$t('allocationUserStorehouseManage.search.rssId')" style="width:100%" clearable>
            <el-option v-for="item in allocationUserStorehouseManageInfo.resourceStoreSpecifications" :key="item.rssId"
              :label="item.specName" :value="item.rssId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.startUserId"
            :placeholder="$t('allocationUserStorehouseManage.search.startUserId')" clearable />
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="allocationUserStorehouseManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.startUserName"
            :placeholder="$t('allocationUserStorehouseManage.search.startUserName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.acceptUserId"
            :placeholder="$t('allocationUserStorehouseManage.search.acceptUserId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="allocationUserStorehouseManageInfo.conditions.acceptUserName"
            :placeholder="$t('allocationUserStorehouseManage.search.acceptUserName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="allocationUserStorehouseManageInfo.conditions.startTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('allocationUserStorehouseManage.search.startTime')"
            style="width:100%" />
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="allocationUserStorehouseManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-date-picker v-model="allocationUserStorehouseManageInfo.conditions.endTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('allocationUserStorehouseManage.search.endTime')"
            style="width:100%" />
        </el-col>
      </el-row>
      <template #actions>
        <el-button type="primary" size="small" icon="el-icon-search" @click="queryAllocationUserStorehouse">
          {{ $t('common.search') }}
        </el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetAllocationUserStorehouse">
          {{ $t('common.reset') }}
        </el-button>
        <el-button size="small" type="text" @click="toggleMoreCondition">
          {{ allocationUserStorehouseManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
          <i :class="allocationUserStorehouseManageInfo.moreCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
        </el-button>
      </template>
    </ds-search-panel>

    <div class="ds-panel">
      <ds-toolbar :total="page.total" :density="density" :show-column-setting="false"
        @update:density="density = $event" @refresh="listAllocationUserStorehouses">
        <template #left><span class="ds-panel__title">{{ $t('allocationUserStorehouseManage.list.title') }}</span></template>
        <template #right>
          <el-button size="mini" icon="el-icon-download" @click="exportExcel">{{ $t('common.export') }}</el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="allocationUserStorehouseManageInfo.allocationUserStorehouses" :loading="loading"
        :error="hasError" :error-message="errorMessage" :density="density" border
        :empty-description="$t('allocationUserStorehouseManage.page.empty')" @retry="listAllocationUserStorehouses">
        <el-table-column prop="ausId" :label="$t('allocationUserStorehouseManage.table.ausId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.ausId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="resId" :label="$t('allocationUserStorehouseManage.table.resId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resId || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('allocationUserStorehouseManage.table.resType')" align="center" min-width="140">
          <template slot-scope="scope">{{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('allocationUserStorehouseManage.table.resName')" align="center" min-width="130" />
        <el-table-column :label="$t('allocationUserStorehouseManage.table.specName')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.specName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('allocationUserStorehouseManage.table.isFixedName')" align="center" width="100" />
        <el-table-column prop="startUserId" :label="$t('allocationUserStorehouseManage.table.startUserId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.startUserId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="startUserName" :label="$t('allocationUserStorehouseManage.table.startUserName')" align="center" width="110" />
        <el-table-column prop="acceptUserId" :label="$t('allocationUserStorehouseManage.table.acceptUserId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.acceptUserId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="acceptUserName" :label="$t('allocationUserStorehouseManage.table.acceptUserName')" align="center" width="110" />
        <el-table-column :label="$t('allocationUserStorehouseManage.table.stock')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('allocationUserStorehouseManage.table.giveQuantity')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.giveQuantity }}{{ scope.row.miniUnitCodeName }}</span></template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('allocationUserStorehouseManage.table.createTime')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('allocationUserStorehouseManage.table.remark')" align="center" min-width="130">
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="page.current" :size="page.size" :total="page.total"
        :summary="`${$t('allocationUserStorehouseManage.total.subTotal')}${$t('allocationUserStorehouseManage.total.quantity')}${allocationUserStorehouseManageInfo.subTotalQuantity} / ${$t('allocationUserStorehouseManage.total.highTotal')}${$t('allocationUserStorehouseManage.total.quantity')}${allocationUserStorehouseManageInfo.highTotalQuantity}`"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listAllocationUserStorehouses, listResourceStoreTypes, listResourceStoreSpecifications, exportData } from '@/api/resource/allocationUserStorehouseManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'

export default {
  name: 'AllocationUserStorehouseManageList',
  components: { DsPageHeader, DsSearchPanel, DsToolbar, DsDataTable, DsPaginationBar },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      communityId: '',
      allocationUserStorehouseManageInfo: {
        allocationUserStorehouses: [],
        total: 0,
        records: 1,
        moreCondition: false,
        subTotalQuantity: '0',
        highTotalQuantity: '0',
        conditions: {
          resId: '', resName: '', acceptUserId: '', acceptUserName: '', startUserId: '', startUserName: '',
          parentRstId: '', rstId: '', rssId: '', ausId: '', startTime: '', endTime: '', communityId: ''
        },
        resourceStoreTypes: [],
        resourceStoreSonTypes: [],
        resourceStoreSpecifications: []
      },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.allocationUserStorehouseManageInfo.conditions.communityId = this.communityId
    this.initData()
  },
  methods: {
    async initData() {
      await this.listAllocationUserStorehouses()
      await this.listResourceStoreTypes()
    },
    async listAllocationUserStorehouses() {
      try {
        this.loading = true
        this.hasError = false
        const params = { page: this.page.current, row: this.page.size, ...this.allocationUserStorehouseManageInfo.conditions }
        const { data, total } = await listAllocationUserStorehouses(params)
        this.allocationUserStorehouseManageInfo.allocationUserStorehouses = data
        this.page.total = total
        if (data.length > 0) {
          this.allocationUserStorehouseManageInfo.subTotalQuantity = data[0].subTotalQuantity || '0'
          this.allocationUserStorehouseManageInfo.highTotalQuantity = data[0].highTotalQuantity || '0'
        } else {
          this.allocationUserStorehouseManageInfo.subTotalQuantity = '0'
          this.allocationUserStorehouseManageInfo.highTotalQuantity = '0'
        }
      } catch (error) {
        console.error('Failed to fetch allocation user storehouses:', error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    async listResourceStoreTypes() {
      try {
        const params = { page: 1, row: 100, communityId: this.communityId, parentId: '0' }
        const { data } = await listResourceStoreTypes(params)
        this.allocationUserStorehouseManageInfo.resourceStoreTypes = data
      } catch (error) {
        console.error('Failed to fetch resource store types:', error)
      }
    },
    async listResourceStoreSonTypes() {
      this.allocationUserStorehouseManageInfo.conditions.rstId = ''
      this.allocationUserStorehouseManageInfo.resourceStoreSonTypes = []
      if (!this.allocationUserStorehouseManageInfo.conditions.parentRstId) return
      try {
        const params = { page: 1, row: 100, communityId: this.communityId, parentId: this.allocationUserStorehouseManageInfo.conditions.parentRstId }
        const { data } = await listResourceStoreTypes(params)
        this.allocationUserStorehouseManageInfo.resourceStoreSonTypes = data
      } catch (error) {
        console.error('Failed to fetch resource store son types:', error)
      }
    },
    async listResourceStoreSpecifications() {
      this.allocationUserStorehouseManageInfo.resourceStoreSpecifications = []
      this.allocationUserStorehouseManageInfo.conditions.rssId = ''
      if (!this.allocationUserStorehouseManageInfo.conditions.rstId) return
      try {
        const params = { page: 1, row: 100, communityId: this.communityId, rstId: this.allocationUserStorehouseManageInfo.conditions.rstId }
        const { data } = await listResourceStoreSpecifications(params)
        this.allocationUserStorehouseManageInfo.resourceStoreSpecifications = data
      } catch (error) {
        console.error('Failed to fetch resource store specifications:', error)
      }
    },
    queryAllocationUserStorehouse() {
      this.page.current = 1
      this.listAllocationUserStorehouses()
    },
    resetAllocationUserStorehouse() {
      this.allocationUserStorehouseManageInfo.conditions = {
        resId: '', resName: '', acceptUserId: '', acceptUserName: '', startUserId: '', startUserName: '',
        parentRstId: '', rstId: '', rssId: '', ausId: '', startTime: '', endTime: '', communityId: this.communityId
      }
      this.allocationUserStorehouseManageInfo.resourceStoreSonTypes = []
      this.allocationUserStorehouseManageInfo.resourceStoreSpecifications = []
      this.page.current = 1
      this.listAllocationUserStorehouses()
    },
    toggleMoreCondition() {
      this.allocationUserStorehouseManageInfo.moreCondition = !this.allocationUserStorehouseManageInfo.moreCondition
    },
    async exportExcel() {
      try {
        const params = { pagePath: 'allocationUserStorehouseManage', ...this.allocationUserStorehouseManageInfo.conditions }
        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('Failed to export:', error)
        this.$message.error(this.$t('allocationUserStorehouseManage.exportFailed'))
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this.listAllocationUserStorehouses()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.listAllocationUserStorehouses()
    }
  }
}
</script>

<style lang="scss" scoped>
.allocation-user-storehouse-manage-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); } }
</style>
